import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/DeleteInvoice.css";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import { AppContext } from "../../../AppProvider";
import { InvoiceContext } from "./InvoiceProvider";
const DeleteInvoice = () =>{
    const {user,logout} = useContext(AppContext);
    const [deletingInvoiceStatus,setDeletingInvoiceStatus] = useState('');
    const {
        setReloadInvoices,
        selectedToDeleteInvoice,setSelectedToDeleteInvoice
    } = useContext(InvoiceContext);
    const deleteInvoice = async () =>{
        try{
            setDeletingInvoiceStatus('deleting');
            const url = `${billingMicroserviceUrl}/tenants/invoices/${selectedToDeleteInvoice?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                setDeletingInvoiceStatus('deleted');
                setReloadInvoices(true);
                return;
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`status code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when deleting invoice with invoice no: ${selectedToDeleteInvoice?.invoiceNumber}`,error);
        }
        setDeletingInvoiceStatus('error');
    };
    useEffect(() =>{
        const handleEsc = (e) =>{
            if(e.key === "Escape" && deletingInvoiceStatus !== 'deleting') setSelectedToDeleteInvoice(null);
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToDeleteInvoice,deletingInvoiceStatus]);
    useEffect(() =>{
        setDeletingInvoiceStatus('');
    },[selectedToDeleteInvoice]);
    if(!selectedToDeleteInvoice) return null;
    return(
        <div className="tenant-administrator-delete-invoice-parent-container">
            {deletingInvoiceStatus === ''?
                (
                    <div className="tenant-administrator-delete-invoice-container">
                        <h1>Delete invoice "{selectedToDeleteInvoice?.invoiceNumber || ''}"?</h1>
                        <p>Once you delete the invoice, it can't be undone.</p>
                        <div className="tenant-administrator-delete-invoice-buttons-container">
                            <button className="cancel-delete-button"
                                onClick={() => setSelectedToDeleteInvoice(null)}>
                                Don't delete
                            </button>
                            <button className="delete-button"
                                onClick={async() => await deleteInvoice()}>
                                Delete invoice
                            </button>
                        </div>
                        <div className="tenant-administrator-delete-invoice-escape-button-container"
                            onClick={() => setSelectedToDeleteInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):deletingInvoiceStatus === 'deleting'?
                (
                    <div className="tenant-administrator-deleting-invoice-container">
                        <div></div>
                        <p>Deleting invoice. Please wait...</p>
                    </div>
                ):deletingInvoiceStatus === 'deleted'?
                (
                    <div className="tenant-administrator-deleted-invoice-container">
                        <h1>Invoice deleted</h1>
                        <p>Invoice "{selectedToDeleteInvoice?.invoiceNumber}" deleted successfully</p>
                        <div className="tenant-administrator-deleted-invoice-okay-button-container">
                            <button onClick={() =>{
                                setSelectedToDeleteInvoice(null);
                            }}>Okay</button>
                        </div>
                        <div className="tenant-administrator-deleted-invoice-escape-button-container"
                            onClick={() => setSelectedToDeleteInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-invoice-delete-error-container">
                        <h1>Error</h1>
                        <p>An error occurred when deleting invoice "{selectedToDeleteInvoice?.invoiceNumber}"</p>
                        <div className="tenant-administrator-invoice-delete-error-okay-button-container">
                            <button onClick={() =>{
                                setSelectedToDeleteInvoice(null);
                            }}>Okay
                            </button>
                        </div>
                        <div className="tenant-administrator-invoice-delete-error-escape-button-container"
                            onClick={() => setSelectedToDeleteInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default DeleteInvoice;